import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getOteConType = (oteConTypeId: number | undefined): Promise<IGetOteConType> => {
  return axiosDefaultApi.get(`/api/OteConTypes/GetOteConTypeViaID/${oteConTypeId}`);
};

type QueryFnType = typeof getOteConType;

type UseGetOteConTypeOptions = {
  oteConTypeId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetOteConType = ({ oteConTypeId , config }: UseGetOteConTypeOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getOteConType_${oteConTypeId}`],
    queryFn: () => getOteConType(oteConTypeId),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση του Είδους γραμμής ΟΤΕ.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};